"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeFilterEmptyResult = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var AttributeFilterEmptySearchResult_1 = require("./AttributeFilterEmptySearchResult");
var AttributeFilterEmptyAttributeResult_1 = require("./AttributeFilterEmptyAttributeResult");
var AttributeFilterEmptyFilteredResult_1 = require("./AttributeFilterEmptyFilteredResult");
/**
 * This component displays different types of messages for situations when all elements are filtered out.
 * It distinguishes messages when current criteria return empty results or all elements are filtered by parents or by search.
 * @beta
 */
exports.AttributeFilterEmptyResult = function (_a) {
    var height = _a.height, totalItemsCount = _a.totalItemsCount, searchString = _a.searchString, isFilteredByParentFilters = _a.isFilteredByParentFilters, _b = _a.parentFilterTitles, parentFilterTitles = _b === void 0 ? [] : _b;
    var renderEmptyResult = null;
    var style = react_1.useMemo(function () {
        return {
            height: height,
        };
    }, [height]);
    if (totalItemsCount === 0) {
        renderEmptyResult = react_1.default.createElement(AttributeFilterEmptyAttributeResult_1.AttributeFilterEmptyAttributeResult, null);
    }
    else if (isFilteredByParentFilters) {
        renderEmptyResult = (react_1.default.createElement(AttributeFilterEmptyFilteredResult_1.AttributeFilterAllValuesFilteredResult, { parentFilterTitles: parentFilterTitles }));
    }
    else if (searchString.length > 0) {
        renderEmptyResult = react_1.default.createElement(AttributeFilterEmptySearchResult_1.AttributeFilterEmptySearchResult, null);
    }
    return (react_1.default.createElement("div", { className: "gd-attribute-filter-empty-result__next", style: style }, renderEmptyResult));
};
//# sourceMappingURL=AttributeFilterEmptyResult.js.map